import React from 'react';
import type { BM3Metric } from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/types.tsx';
import { metrics } from '@atlassian/browser-metrics';
import DigestsNotificationsPersonalSettings from '@atlassian/jira-personal-settings-digest-notifications/src/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { NotFoundErrorPageAsync } from '@atlassian/jira-error-pages/src/async.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { withRouter } from '@atlassian/react-resource-router';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import LoginRedirect from '@atlassian/jira-common-navigation/src/login-redirect/index.tsx';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import { DigestsNotificationsPageTitle } from './ui/index.tsx';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const DigestsNotificationsPersonalSettingsPageLoad = metrics.pageLoad({
	key: 'personal-settings-digests-notifications',
	ssr: {
		doneAsFmp: true,
	},
}) as unknown as BM3Metric;

export const DigestsNotificationsPersonalSettingsShell = () => {
	const accountId = useAccountId();
	let content;
	if (!accountId) {
		content = <LoginRedirect />;
	} else if (expValEquals('due_date_notifications_notifications_panel_toggle', 'isEnabled', true)) {
		content = (
			<>
				<DigestsNotificationsPersonalSettings />
				<SubmitApdex
					appName="personal-settings-digests-notifications"
					metric={DigestsNotificationsPersonalSettingsPageLoad}
					isExpectedToHaveSsr
				/>
				<SubProductUpdater subProduct="platform" />
				<DigestsNotificationsPageTitle />
			</>
		);
	} else {
		content = <NotFoundErrorPageAsync />;
	}
	return (
		<UFOSegment name="personal-settings-digests-notifications">
			<MarkProductStart />
			{content}
		</UFOSegment>
	);
};

export default withRouter(DigestsNotificationsPersonalSettingsShell);
